var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 16c-4.419 0-8-3.581-8-8s3.581-8 8-8 8 3.581 8 8-3.581 8-8 8zm5.6 2c4.637 0 8.4 3.762 8.4 8.4V29c0 1.656-1.344 3-3 3H3c-1.656 0-3-1.344-3-3v-2.6C0 21.763 3.763 18 8.4 18h1.044c1.394.637 2.931 1 4.556 1s3.169-.363 4.556-1H19.6z"}));
}

User.defaultProps = {"viewBox":"0 0 28 32"};

module.exports = User;

User.default = User;
